<template>
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 class="mb-sm-0">Form Pegawai</h4>

            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item">
                  <Link href="/admin/indagpegawai">Data Pegawai</Link>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end page title -->

      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <div>
                  <h4 class="card-title">Form Data Pegawai</h4>
                  <p class="card-title-desc mb-0">Tambah atau ubah kelengkapan data pegawai.</p>
                </div>
              </div>

              <hr>

              <Profile :pegawai="pegawai" :master="{ jabatan, pangkat, golongan, bidang }" @action="action" @uploadGambar="uploadGambar" />

            </div>
          </div>
        </div>
      </div>
      <!-- end row -->
    </div>
    <!-- container-fluid -->
  </div>
</template>

<script>
import Layout from '@/layout/Index'
import Profile from '@/components/Profile'
import axios from 'axios'

export default {
  layout: Layout,
  components: { Profile },
  props: {
    pegawai: Object,
    jabatan: Array,
    pangkat: Array,
    golongan: Array,
    bidang: Array,
  },
  data() {
    return {}
  },
  methods: {
    action(form) {
      if(form.id) {
        this.$inertia.put(`/admin/indagpegawai/${form.id}`, form);
      } else {
        this.$inertia.post('/admin/indagpegawai/tambah', form);
      }
    },
    uploadGambar(gambar) {
      const bodyFormData = new FormData();
      bodyFormData.append('file', gambar);
      axios({
        method: 'post',
        url: '/admin/berkas/profile',
        data: bodyFormData,
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then(res => {
        const { id, url } = res.data;
        this.form.berkas_profile_id = id;
        this.form.profile_url = url;
      }).catch(() => {});
    }
  }
}
</script>
